<template>
    <component :is="dynamicComponent" />
</template>
<script>
    import { shallowRef, onMounted, watch } from "vue";
    import { useRouter } from "vue-router";
    import { useStore } from "vuex";

    import PageNotFound from "@/components/PageNotFound.vue";
    import NotFoundView from "@/views/NotFoundView.vue";
    import { StoreUser } from "@/store/constants";

    export default {
        name: "DynamicComponent",
        props: {
            path: {
                type: String,
                default: '',
            },
        },
        setup(props) {
            const router = useRouter();
            const store = useStore();

            const dynamicComponent = shallowRef(null);
            const loadComponent = async () => {
                try {
                    const { default: component } = await import(`@/${props.path}.vue`);
                    dynamicComponent.value = component;
                } catch (error) {
                    if (store.getters[StoreUser.get] && store.getters[StoreUser.get].userType) {
                        console.warn('Bileşen yüklenirken bir hata oluştu:', error);
                        dynamicComponent.value = PageNotFound;
                    }
                }
            };
            onMounted(loadComponent);
            watch(() => props.path, loadComponent);
            return { dynamicComponent };
        },
    };
</script>